//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ClearSearch, SearchResults } from 'redux/actions';

//firebase
import { db } from 'assets/firebase';

// @material-ui/style
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import CircularProgress from "@material-ui/core/CircularProgress";
import CustomSelect from "components/Select/Select.jsx";

//materialKit components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";

import TeacherEditor from "components/TeacherEditor/TeacherEditor.jsx";
import ConfirmDialog from "components/ConfirmDialog/ConfirmDialog.jsx";

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

class TeacherList extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      teachers: [],
      selectedSchool: props.schools[0].id
    }

    this.teacherUpdated = this.teacherUpdated.bind(this);
    this.deleteTeacher = this.deleteTeacher.bind(this);
  }

  componentWillMount() {
    
    var classes = [];
    for(var i = 0; i < this.props.classRooms.length; i++) 
      classes.push({key: this.props.classRooms[i].id, label: this.props.classRooms[i].Name});
    
    this.setState({classRooms: classes});

    var schools = [];
    for(var j = 0; j < this.props.schools.length; j++) 
      schools.push({key: this.props.schools[j].id, label: this.props.schools[j].Name});
    
    this.setState({schools});

    this.filterTeachers(this.state.selectedSchool);  
  }

  filterTeachers(schoolID) {

    this.setState({selectedSchool: schoolID, teachers: []}, function() {

      db.getUsersBySchool(schoolID).then(snapshot => {
        
        var staff = [];
        snapshot.forEach((doc) => {
  
          var user = doc.data();
          if(user.UserType !== 'student') {
            user.id = doc.id;
            if(!user.Photos)
              user.Photos = [];
            staff.unshift(user);
          } 
        });

        this.setState({teachers: staff});
      });
    });
  }

  teacherUpdated() {
    this.filterTeachers(this.state.selectedSchool);
  }

  deleteTeacher(teacher) {

    console.log(teacher);

    // delete from db
    db.deleteUser(teacher.id).then(() => {

      // Check if we're in search mode
      if (this.props.search.active) {
        // Update search results in Redux
        const updatedResults = this.props.search.results.filter(user => user.id !== teacher.id);
        this.props.onSearchResults(updatedResults);
      } else {
        // remove from in-memory list
        var objs = this.state.teachers;
        
        for(var i = 0; i < objs.length; i++) {
          if(objs[i].id === teacher.id) {
            objs.splice(i,1);
            break;
          }
        }
        this.setState({teachers:objs});
      }

      // remove firebase login
      var data = {
        uid: teacher.id
      }

      fetch("https://us-central1-keiki-262db.cloudfunctions.net/deleteUser", {
        method: "POST", 
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      })
      .then((response) => {
          if(response.ok) {
              // todo, delete from intercom too
          } else {
            console.log("error1");  
            console.log(response);
          }
      })
      .catch((error) => {
          // If there is any error you will catch them here
          console.log("error2: " + error);
      });
    });
  }

  getUserType(user) {
    if(user.UserType === 'teacher')
      return <div style={{color:"gray"}}>Teacher</div>
    else if (user.UserType === 'principal')
      return <div style={{color:"green"}}>Principal</div>
    else if (user.UserType === 'assistant-principal')
      return <div style={{color:"green"}}>Assistant Principal</div>
    else if (user.UserType === 'counselor')
      return <div style={{color:"purple"}}>Counselor</div>
    else if (user.UserType === 'para')
      return <div style={{color:"purple"}}>Para Educator</div>
    else if (user.UserType === 'nurse')
      return <div style={{color:"blue"}}>Nurse</div>
    else if (user.UserType === 'administrative')
      return <div style={{color:"pink"}}>Adminstrative</div>
    else if (user.UserType === 'admin')
      return <div style={{color:"pink"}}>ATEQ Admin</div>
    else if (user.UserType === 'pta')
      return <div style={{color:"orange"}}>PTA</div>
  }

  render() {
    const { classes, search } = this.props;

    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }

    ReactGA.pageview("admin.allthingseq.com/teachers");
    
    // Use search results if search is active, otherwise use filtered teachers
    const displayUsers = search.active ? search.results : this.state.teachers;

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success">
              <GridContainer>
                <GridItem xs={12} sm={12} md={10}>
                  <h4 className={classes.cardTitleWhite}>
                    {search.active ? `Search Results for "${search.query}"` : 'School Staff'}
                  </h4>
                </GridItem>
                <GridItem xs={12} sm={12} md={2} style={{textAlign:"right"}}>
                  <Tooltip
                      id="tooltip-top-start"
                      title="Add"
                      placement="left"
                      classes={{ tooltip: classes.tooltip }}
                    >
                      <TeacherEditor onChange={this.teacherUpdated} 
                        schoolID={this.state.selectedSchool}
                        userType={this.props.userType}
                        newUser={true}
                        teacher={{
                          FirstName: "",
                          LastName: "",
                          EmailAddress: "",
                          Photos: [],
                          Password: "",
                          UserType: "",
                          SchoolID: this.state.selectedSchool,
                          orgId: this.props.org.id
                        }} />
                  </Tooltip>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
            <GridContainer>
              <GridItem xs={false} sm={false} md={8}>
                  {search.active && (
                    <Button 
                      color="primary" 
                      onClick={() => {
                        this.props.onClearSearch();
                        this.filterTeachers(this.state.selectedSchool);
                      }}
                    >
                      Clear Search
                    </Button>
                  )}
              </GridItem>
                <GridItem xs={12} sm={12} md={4} >
                  {!search.active && (
                    <CustomSelect
                      id="schools"
                      labelText="School"
                      inputProps={{
                          placeholder: "Choose a School"
                      }}
                      formControlProps={{
                          fullWidth: true
                      }}
                      onChange={(e) => this.filterTeachers(e.target.value)}
                      options={this.state.schools}
                      value={this.state.selectedSchool}
                    />
                  )}
                </GridItem>
              </GridContainer>
              {search.loading ? (
                <div style={{textAlign: 'center', padding: '50px'}}>
                  <CircularProgress />
                  <p style={{marginTop: '20px', color: '#999'}}>Searching users...</p>
                </div>
              ) : (
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{width:"54px", padding:"3px"}}>
                      &nbsp;
                    </TableCell>
                    <TableCell style={{padding:"3px"}}>
                        Last Name
                    </TableCell>
                    <TableCell style={{padding:"3px"}}>
                        First Name
                    </TableCell>
                    <TableCell style={{padding:"3px"}}>
                        Email
                    </TableCell>
                    <TableCell style={{padding:"3px"}}>
                        {search.active ? 'School' : 'User Type'}
                    </TableCell>
                    <TableCell style={{width:"54px", padding:"3px"}}>
                        &nbsp;
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {displayUsers.map((value,index) => (
                    <TableRow key={index} className={classes.tableRow}>
                      <TableCell className={classes.tableActions} style={{width:"54px", padding:"3px"}}>
                        {value.hasFirestoreRecord !== false ? (
                          <Tooltip
                            id="tooltip-top"
                            title="Edit Teacher"
                            placement="top"
                            classes={{ tooltip: classes.tooltip }}
                          >
                           <TeacherEditor teacher={value} 
                              schoolID={value.SchoolID || this.state.selectedSchool} 
                              userType={this.props.userType}
                              onChange={this.teacherUpdated} />
                          </Tooltip>
                        ) : (
                          <div style={{width:"54px"}}>&nbsp;</div>
                        )}
                      </TableCell>
                      <TableCell className={classes.tableCell} style={{padding:"3px"}}>
                        {value.LastName}
                      </TableCell>
                      <TableCell className={classes.tableCell} style={{padding:"3px"}}>
                        {value.FirstName}
                      </TableCell>
                      <TableCell className={classes.tableCell} style={{padding:"3px"}}>
                        {value.EmailAddress || value.email}
                        {search.active && !value.hasFirestoreRecord && (
                          <div style={{color:"orange", fontSize:"12px"}}>Auth only - no profile data</div>
                        )}
                      </TableCell>
                      <TableCell className={classes.tableCell} style={{padding:"3px"}}>
                        {search.active ? (
                          <div>{value.SchoolName || 'No School'}</div>
                        ) : (
                          this.getUserType(value)
                        )}
                      </TableCell>
                      <TableCell className={classes.tableActions} style={{width:"54px", padding:"3px"}}>
                        <Tooltip id="tooltip-top-start" title="Delete Staff Member" placement="top" classes={{ tooltip: classes.tooltip }} >
                          <ConfirmDialog header="Confirm Delete" description="Are you sure you want to delete this staff member? This action cannot be undone." confirmed={() => this.deleteTeacher(value)} />
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    onClearSearch: ClearSearch,
    onSearchResults: SearchResults
  }, dispatch);  
}

TeacherList = connect(mapStateToProps, mapDispatchToProps)(TeacherList);
export default withStyles(styles)(TeacherList);



// WEBPACK FOOTER //
// ./src/views/TeacherList/TeacherList.jsx